import { z } from 'zod';
export const SearchSchema = z.object({
  tab: z.enum(['active', 'archive']).optional(),
  operationPackageId: z.string().optional(),
  operationPackagePatternId: z.string().optional(),
  pageIndex: z.number().int().nonnegative().catch(0),
  pageSize: z.number().int().positive().catch(50),
  targetId: z.string().optional(),
  targetName: z.string().optional()
});